import { configureStore } from "@reduxjs/toolkit";
import { rootApi } from "../api/rootApi";
import patientReducer from "../slices/patientSlice";
import authReducer from "../slices/authSlice";
import userReducer from "../slices/userSlice";
import appointmentReducer from "../slices/appointmentsSlice";
import paymentReducer, { setPaymentData } from "../slices/paymentSlice";
import {
  readLocalStorageJSON,
  scrubCorruptLocalStorage,
} from "../utils/safeLocalStorage";

scrubCorruptLocalStorage([
  "selectedPatient",
  "selectedUser",
  "appointments",
  "paymentData",
  "patientList",
]);

const store = configureStore({
  reducer: {
    [rootApi.reducerPath]: rootApi.reducer,
    patient: patientReducer,
    auth: authReducer,
    user: userReducer,
    appointments: appointmentReducer,
    payment: paymentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rootApi.middleware),
});

const initializePatientState = () => {
  const parsedPatient = readLocalStorageJSON("selectedPatient", null);
  if (!parsedPatient) return;

  store.dispatch({
    type: "patient/setSelectedPatient",
    payload: parsedPatient,
  });
  store.dispatch({
    type: "user/setSelectedUser",
    payload: parsedPatient,
  });
};

const initializeAuthState = () => {
  const authToken = localStorage.getItem("authToken");
  if (authToken && authToken !== "undefined" && authToken !== "null") {
    store.dispatch({
      type: "auth/setToken",
      payload: authToken,
    });
  } else if (authToken === "undefined" || authToken === "null") {
    localStorage.removeItem("authToken");
  }
};

const initializeAppointmentState = () => {
  const storedAppointments = readLocalStorageJSON("appointments", null);
  if (!storedAppointments) return;

  store.dispatch({
    type: "appointments/setAppointments",
    payload: storedAppointments,
  });
};

const initializePaymentState = () => {
  const paymentObj = readLocalStorageJSON("paymentData", null);
  if (!paymentObj) return;
  store.dispatch(setPaymentData(paymentObj));
};

initializePatientState();
initializeAuthState();
initializeAppointmentState();
initializePaymentState();

export default store;
